import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseMutationResult, useMutation, useQueryClient } from "@tanstack/react-query";
import { handleJsonApiError } from "jsonapi-zod-query";

export const useDeleteNote = (): UseMutationResult<void, Error, { noteUUID: string }> => {
    const fetch = useAuthenticatedFetch();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ noteUUID }) => {
            const response = await fetch(apiUrl("/note/delete"), {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                },
                body: JSON.stringify({
                    noteUUID: noteUUID,
                }),
            });
            await handleJsonApiError(response);
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ["case-notes"],
            });
            await queryClient.invalidateQueries({
                queryKey: ["case-media"],
            });
            await queryClient.invalidateQueries({
                queryKey: ["notification-history"],
            });
        },
    });
};
